export class KYC {
    static readonly  NONE = 'none';
    static readonly MANUAL = 'manual';
    static readonly AUTO = 'auto';
    static readonly CUSTOM = 'custom';

    constructor() {}
}
